export const trueTypeOf = (obj: any) =>
  Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
